/**
 * Requires
 */

import $ from 'jquery'
import Blazy from 'blazy'

/**
 * Initialisation
 */

export const initialise = () => {
  const bLazy = new Blazy({
    selector: '.lazy',
    successClass: 'loaded',
    errorClass: 'error',
    success: el => {
      const parent = el.parentElement
      if (parent && parent.classList.contains('spinner')) {
        parent.classList.remove('spinner')
      }
    },
  })

  // make images lazy load in when content changes
  $(document).on('ajax.replace', () => {
    setTimeout(() => {
      bLazy.revalidate()
    }, 1)
  })
}
